module.exports = __webpack_public_path__ + "img/burger-chips.45f4f809.png";